import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Google Analytics Tracking ID
// Replace 'G-XXXXXXXXXX' with your actual Google Analytics ID
const GA_TRACKING_ID = 'G-XXXXXXXXXX';

export const GoogleAnalytics = () => {
  const location = useLocation();

  useEffect(() => {
    // Only run if GA_TRACKING_ID is set
    if (GA_TRACKING_ID && GA_TRACKING_ID !== 'G-XXXXXXXXXX') {
      // Track page views
      if (window.gtag) {
        window.gtag('config', GA_TRACKING_ID, {
          page_path: location.pathname + location.search,
        });
      }
    }
  }, [location, GA_TRACKING_ID]); // Added GA_TRACKING_ID to dependencies

  return null;
};

// Initialize Google Analytics
export const initGA = () => {
  if (GA_TRACKING_ID && GA_TRACKING_ID !== 'G-XXXXXXXXXX') {
    // Load Google Analytics script
    const script1 = document.createElement('script');
    script1.async = true;
    script1.src = `https://www.googletagmanager.com/gtag/js?id=${GA_TRACKING_ID}`;
    document.head.appendChild(script1);

    // Initialize gtag
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      window.dataLayer.push(arguments);
    }
    window.gtag = gtag;
    gtag('js', new Date());
    gtag('config', GA_TRACKING_ID);
  }
};

// Track custom events
export const trackEvent = (eventName, eventParams = {}) => {
  if (window.gtag && GA_TRACKING_ID !== 'G-XXXXXXXXXX') {
    window.gtag('event', eventName, eventParams);
  }
};

/*
 * HOW TO SET UP GOOGLE ANALYTICS:
 * 
 * 1. Go to https://analytics.google.com
 * 2. Click "Start measuring" or "Admin" > "Create Property"
 * 3. Follow the setup wizard to create a GA4 property
 * 4. Copy your Measurement ID (looks like G-XXXXXXXXXX)
 * 5. Replace 'G-XXXXXXXXXX' above with your actual ID
 * 6. That's it! Analytics will start tracking automatically
 * 
 * WHAT GETS TRACKED:
 * - Page views (automatic)
 * - Form submissions (when using trackEvent function)
 * - Button clicks (when using trackEvent function)
 * - User demographics and behavior
 * 
 * VIEW YOUR DATA:
 * - Go to https://analytics.google.com
 * - Select your property
 * - View real-time data, reports, and insights
 */
